import { useRequesterStore } from '../stores/requester'
import type { SaveAccountPayload } from '../types/account'

let requesterX: ReturnType<typeof useRequesterStore> | undefined

function getRequester() {
  requesterX ??= useRequesterStore()
  return requesterX
}

export async function getAllAccounts() {
  return getRequester().Get({
    route: '/account',
    withAuth: true,
  })
}

export async function createAccount(body: SaveAccountPayload) {
  return getRequester().Post({
    route: '/account/create',
    withAuth: true,
    body,
  })
}

export async function deleteAccount(id: number) {
  return getRequester().Delete({
    route: `/account/delete/${id}`,
    withAuth: true,
  })
}
